import React, { useMemo } from "react";

import "./TradealgoProducts.scss";
import useAuth from "../../contexts/Auth/useAuth";
import TradealgoProduct from "./TradealgoProduct";
import WSProductLogo from "../../assets/images/wealth-series-signup/product-logo.png";
import WSLiteLogo from "../../assets/images/wealth-series/ws-lite-light.png";
import WSCore from "../../assets/images/wealth-series/ws-core.png";
import { connect } from "react-redux";
const TradealgoProducts = ({ themeMode }) => {
  const {
    emeraldPath,
    platinumProgramPath,
    optionsMentorshipPath,
    optionsAcademyPath,
    hasWealthSeriesLite,
    wsLiteCompletedOnboarding,
  } = useAuth();

  const wealthSeriesProducts = useMemo(() => {
    return [
      {
        title: "",
        isLogoTitle: true,
        logo: WSCore,
        description1: "Elevated trading with exclusive tools and insights,",
        description2: "powered by AI.",
        buttonLink: "/wealth-series-core-signup",
        type: "wealth-series-core",
        checkout: false,
        isComingSoon: false,
      },
      {
        title: "",
        isLogoTitle: true,
        logo: WSProductLogo,
        description1: "Leverage on cutting-edge AI technology coupled with",
        description2: "advanced diversification techniques.",
        buttonLink: "/wealth-series-signup",
        type: "wealth-series",
        checkout: false,
        isComingSoon: false,
      },
      {
        title: "",
        isLogoTitle: true,
        logo: WSLiteLogo,
        description1: "Smart, AI stock recommendations designed to fit every",
        description2: "investor's strategy, from beginners to experts.",
        buttonLink: hasWealthSeriesLite
          ? wsLiteCompletedOnboarding
            ? `/wealth-series-lite/ai-top-picks`
            : `/wealth-series-lite-onboarding`
          : `/wealth-series-lite-signup`,
        type: "wealth-series-lite",
        checkout: false,
        isComingSoon: false,
        isDarkLogo: true,
      },
    ];
  }, [themeMode, hasWealthSeriesLite, wsLiteCompletedOnboarding]);

  const otherProducts = useMemo(() => {
    return [
      {
        title: "TRADEALGO TERMINAL",
        description1: "Trade smarter, trade better—",
        description2: "experience TradeAlgo at its best",
        buttonLink:
          "https://checkout.tradealgo.com/OTesZx3zJo37D6UnR0vGPjMCQDmHx4cazhk-RsPLuaV_qzfh",
        type: "terminal",
        checkout: true,
        logoAlwaysDark: true,
      },
      {
        title: "EMERALD INCOME ALERTS",
        description1: "Elevate your trading strategy and",
        description2: "boost your profit with Credit Spreads",
        buttonLink: emeraldPath,
        type: "emerald",
        logoAlwaysDark: true,
      },
      {
        title: "PLATINUM PROGRAM",
        description1: "Profitable options trading",
        description2: "made easy",
        buttonLink: platinumProgramPath,
        type: "platinum",
        logoAlwaysDark: true,
      },
      {
        title: "TRADEGPT",
        description1: "Your AI Trading Assistant",
        description2: "Empower Your Trading Decisions with AI-Driven Insights",
        buttonLink: "/tradegpt",
        type: "tradegpt",
      },
      {
        title: "OPTIONS MENTORSHIP",
        description1: "1 on 1 Mentorship with our analysts",
        description2: "and launch your portfolio to new heights",
        buttonLink: optionsMentorshipPath,
        type: "mentorship",
        logoAlwaysDark: true,
      },
      {
        title: "OPTIONS ACADEMY",
        description1: "Demystify the complexities of trading",
        description2: "options",
        buttonLink: optionsAcademyPath,
        type: "academy",
        logoAlwaysDark: true,
      },
    ];
  }, [
    platinumProgramPath,
    optionsMentorshipPath,
    optionsAcademyPath,
    emeraldPath,
  ]);

  return (
    <div className="ta-products">
      <div className="ta-products__container">
        <div className="ta-products__header">
          <div className="ta-products__title">TradeAlgo Products</div>
          <div className="ta-products__subtitle">
            Gain access to powerful trading tools and resources that will help
            you make informed trading decisions.
          </div>
          <div className="ta-products__subtitle">
            Our platform is designed to help traders of all levels, whether
            you&apos;re a beginner or an experienced trader.
          </div>
        </div>

        <div className="ta-products__section">
          <div className="ta-products__section-title">WEALTH SERIES</div>
          <div className="ta-products__wealth-series">
            {wealthSeriesProducts.map((card, index) => (
              <TradealgoProduct key={index} {...card} />
            ))}
          </div>
        </div>

        <div className="ta-products__section">
          <div className="ta-products__section-title">OTHER PRODUCTS</div>
          <div className="ta-products__other-products">
            {otherProducts.map((card, index) => (
              <TradealgoProduct key={index} {...card} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const stateToProps = (state) => ({
  themeMode: state.themeMode.themeMode,
});

export default connect(stateToProps)(TradealgoProducts);
